export default __webpack_public_path__ + "static/seemode-cdf0202b51822a9afbe3aeeb6af536b6.mp4";